import { STREAM_MODE } from '../utils';

export class HLSAdapter {
  connect(streaming, config, onSuccess) {
    console.log('🚀 ~ HLSAdapter ~ connect ~ streaming:', streaming);
    const url =
      streaming?.streamMode === STREAM_MODE.TRANSCODE ||
      streaming?.version === 'v3'
        ? `https://${streaming?.wsHost}:${streaming?.hlsPort}${streaming?.sourcePath || streaming?.path || `/${streaming?.source}`}/index.m3u8?token=${config.streamToken}`
        : streaming?.version === 'v2'
          ? `https://${streaming?.wsHost}:${streaming?.hlsPort}${streaming?.sourcePath || streaming?.path || `/${streaming?.source}`}/index.m3u8?token=${config.streamToken}`
          : `https://${streaming?.wsHost}:${streaming?.hlsPort}/${config.streamToken}${streaming?.path}/index.m3u8`;

    console.log('hls url: ', url);
    console.log(
      'rtsp: ',
      `rtsp://${streaming.serial}:${config.streamToken}@${streaming.wsHost}:${streaming.rtspPort || '10554'}${streaming?.sourcePath ? streaming?.sourcePath : streaming.path || streaming?.source}`,
    );
    onSuccess(url);
  }

  destroy() {
    console.log('DESTROYING THIS INSTANCE');
  }
}
